<span *ngIf="url" class="teams-image-url">
    <img class="teams-image teams-image-desktop" height="16" width="16" [ngSrc]="url" [priority]="index < eagerLoadCount ? true : false" />
</span>
<span *ngIf="!url && worldIcon" class="accordion-header-svg">
    <svg class="header-svg">
        <use [attr.xlink:href]="'#fallback-world-icon'"></use>
    </svg>
</span>
